/* eslint-disable prefer-destructuring */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint-disable max-len */
import _ from 'lodash';
import React, { useEffect, useState, useContext } from "react";
import { ServiceManager } from '@jutro/services';
import { FNOLService } from 'nn-capability-fnol';
import { TranslatorContext } from '@jutro/locale';
import ClientContext from '../../contexts/ClientContext/ClientContext';
import PartnerContext from '../../contexts/PartnerContext/PartnerContext';
import AuthenticatedContext from "../../contexts/AuthenticatedContext/AuthenticatedContext";
import { isWorkingHours } from '../../utils/DateUtil';

function SalesforceChatBot(props) {
    const {
        history
    } = props;

    const NN_CONSULTANT = 'NN_Consultant';
    const localeService = ServiceManager.getService('locale-service');

    const [isBotEnabled, setBotEnabled] = useState(false);
    const [clientDetails, setClientDetails] = useState({});

    const {
        authenticationData,
        policyNumberInUsage
    } = useContext(AuthenticatedContext);
    const translator = useContext(TranslatorContext);
    const partnerContext = useContext(PartnerContext);
    const clientContext = useContext(ClientContext);

    const isWithinWorkingHours = isWorkingHours();

    useEffect(() => {
        if (isWithinWorkingHours && !_.isEmpty(authenticationData) && _.isEmpty(clientDetails)) {
            const chatBotInitialization = {
                authRequestDetails: authenticationData.authenticatedRequestData
            };

            FNOLService.generateChatBotInitializationDetails(chatBotInitialization, history, { partnerContext, translator })
                .then((response) => {
                    setClientDetails(response);
                    setBotEnabled(true);
                }).catch(() => {
                    setBotEnabled(false);
                });
        }
    }, [isWithinWorkingHours, authenticationData, clientDetails]);

    const lan = localeService.getStoredLanguage().substring(0, 2);
    const initESW = (gslbBaseURL) => {
        const embedded_svc = window.embedded_svc;
        embedded_svc.settings.displayHelpButton = true;
        embedded_svc.settings.language = lan;
        embedded_svc.settings.extraPrechatFormDetails = [
            {
                "label": "First Name",
                "value": clientDetails.firstName || "",
                "displayToAgent": true,
                "transcriptFields": ["First_Name__c"]
            },
            {
                "label": "Last Name",
                "value": clientDetails.lastName || "",
                "displayToAgent": true,
                "transcriptFields": ["Last_Name__c"]
            },
            {
                "label": "Email",
                "value": clientDetails.email || "",
                "displayToAgent": true,
                "transcriptFields": ["Email__c"]
            },
            {
                "label": "PartyID",
                "value": clientDetails.partyID || '',
                "displayToAgent": true,
                "transcriptFields": ["PartyID__c"]
            },
            {
                "label": "PolicyNumber",
                "value": policyNumberInUsage,
                "displayToAgent": true,
                "transcriptFields": ["PolicyNumber__c"]
            },
            {
                "label": "TypeOfFlow",
                "value": 'Customer Engage',
                "displayToAgent": true,
                "transcriptFields": ["TypeOfFlow__c"]
            },
            {
                "label": "SubTypeOfFlow",
                "value": clientContext.getFlowDisplayName(),
                "displayToAgent": true,
                "transcriptFields": ["SubTypeOfFlow__c"]
            },
            {
                "label": "FlowStep",
                "value": '', // We'll leave it blank
                "displayToAgent": true,
                "transcriptFields": ["FlowStep__c"]
            },
            {
                "label": "FlowLanguage",
                "value": lan.toUpperCase(),
                "displayToAgent": true,
                "transcriptFields": ["FlowLanguage__c"]
            },
            {
                label: "QueueName",
                value: `NN Claims` || "",
                displayToAgent: true,
                transcriptFields: ["QueueName__c"],
            },
            {
                label: "WorkingHours",
                value: isWithinWorkingHours,
                displayToAgent: true,
                transcriptFields: ["WorkingHours__c"],
            }
        ];

        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';

        embedded_svc.init(
            process.env.REACT_APP_CHATBOT_SANDBOX_SALESFORCE,
            process.env.REACT_APP_CHATBOT_SALESFORCE_AGENT_SETUP_FLOW,
            gslbBaseURL,
            process.env.REACT_APP_CHATBOT_SALESFORCE_ENV_ID,
            NN_CONSULTANT,
            {
                baseLiveAgentContentURL: process.env.REACT_APP_CHATBOT_SALESFORCE_CONTENT_URL,
                deploymentId: process.env.REACT_APP_CHATBOT_SALESFORCE_DEPLOYMENT_ID,
                buttonId: process.env.REACT_APP_CHATBOT_SALESFORCE_BUTTON_ID,
                baseLiveAgentURL: process.env.REACT_APP_CHATBOT_SALESFORCE_BASELIVEAGENT_URL,
                eswLiveAgentDevName: NN_CONSULTANT,
                isOfflineSupportEnabled: false
            }
        );
    };

    const loadScript = () => {
        if (!window.embedded_svc) {
            const script = document.createElement("script");
            script.setAttribute("src", process.env.REACT_APP_CHATBOT_SALESFORCE_ESW_URL);
            script.onload = () => {
                initESW(null);
            };
            document.body.appendChild(script);
        } else {
            initESW("https://service.force.com");
        }
    };

    useEffect(() => {
        if (isWithinWorkingHours && isBotEnabled && !_.isEmpty(policyNumberInUsage) && !_.isEmpty(clientDetails) && clientDetails.chatBotEnabled === true) {
            loadScript();
        }
    }, [clientDetails, isBotEnabled, isWithinWorkingHours, policyNumberInUsage]);

    return (
        <style>
            {`
                .embeddedServiceHelpButton .helpButton .uiButton {
                    background-color: var(--GW-BRAND-COLOR-1);
                    font-family: "Arial", sans-serif;
                }

                .embeddedServiceHelpButton .helpButton .uiButton:focus {
                    outline: 1px solid var(--GW-BRAND-COLOR-1);
                }
            `}
        </style>
    );
}

export default SalesforceChatBot;
